module.exports = __webpack_public_path__ + "static/media/kemenkes.f5c03513.png";